import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import animati from '../clientWeb/animation/first.json';
import { useLocation } from 'react-router-dom';
export default function TimeUpPage() {
  const location = useLocation();
  return (
    <>
      <Player autoplay loop src={animati} style={{ height: '550px', width: '550px' }} />
      <div style={{ textAlign: 'center' }}>
        {location.state.timeOver && (
          <h3 style={{ fontSize: '25px' }}>Sorry, the link has Expired.</h3>
        )}
        {location.state.isActive && (
          <h3 style={{ fontSize: '25px' }}>Sorry, the link has been deactivated.</h3>
        )}
        <br />
        <p style={{ fontSize: '14px', letterSpacing: '1px' }}>
          Please contact the person who shared the link with you for further assistance.
        </p>
      </div>
    </>
  );
}
